import { FC } from "react";
import MultiSelectDropdown from "../../../../loansV2/multi-select-dropdown";
import Button from "../../../../../components/ui/button";
import { PanelSlider } from "../../../../../components/ui";
import cancelIcon from "../../../../../assets/images/close.svg";
import useCollectionFilter from "../bloc/useCollectionFilter";

const CollectionFilterView: FC<{
  open: boolean;
  onClose: () => void;
}> = ({
  open,
  onClose
}) => {

    const {
      paymentModes,
      statuses,
      selectedModes,
      selectedStatuses,
      onSelectMode,
      onResetType,
      onSelectStatus,
      onResetStatus,
      onApply,
      onReset,
      isFilterApplied,
      onSeletCustomer,
      selectedCustomers,
      customerOptions,
      onResetCustomers,
      labelToBackendMap,
      statusMap
    } = useCollectionFilter();

    return (
      <PanelSlider
        open={open}
        onClose={onClose}
        direction="right_to_left"
        style={{ width: "40vw" }}
      >
        <div
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
          className="panel-content"
        >
          <div className="border-b card_space_18 flex items-center justify-between">
            <div className="flex">
              <h1 className="font-bold">
                Filters
              </h1>
            </div>
            <div>
              <img
                src={cancelIcon}
                alt=""
                className="cursor-pointer"
                onClick={onClose}
              />
            </div>
          </div>
          <div>
            {" "}
            <div
              className="p-4 bg-gray-bg"
              style={{
                height: "calc(100vh - 9rem)",
              }}
              id="scroll_style"
            >
              <div className="space_18">
                <div className="flex justify-between">
                  <label className="block font-bold text-sm mb-2">
                    Type
                  </label>

                  <span className="fs-14 color-red cursor-pointer"
                    onClick={onResetType}
                  >Reset</span>
                </div>

                <div className="flex gap-2 flex-wrap">
                  {paymentModes.map((p) => (
                    <button
                      key={p}
                      onClick={() => onSelectMode(p)}
                      className={`px-4 py-2 border br-10 text-sm font-semibold 
                      ${selectedModes.includes("All") || selectedModes.includes(p)
                          ? "bg-primary text-white"
                          : "hover:bg-primary bg-white"
                        }`}
                    >
                      {p}
                    </button>
                  ))}
                </div>
              </div>

              <div className="space_18">
                <div className="flex justify-between">
                  <label className="block font-bold mb-2 text-sm">By Status</label>
                  <span className="fs-14 color-red cursor-pointer"
                    onClick={onResetStatus}
                  >Reset</span>
                </div>

                <div className="flex gap-2 flex-wrap">
                  {statuses.map((t) => {
                    let isSelected = false;

                    if (t === "All") {
                      const allSelected =
                        Object.keys(statusMap).every((code) =>
                          selectedStatuses.includes(code)
                        );
                      isSelected = selectedStatuses.includes("All") || allSelected;
                    } else {
                      isSelected = selectedStatuses.includes(labelToBackendMap[t]);
                    }

                    return (
                      <button
                        key={t}
                        onClick={() => onSelectStatus(t)}
                        className={`px-4 py-2 border br-10 text-sm font-semibold ${isSelected ? "bg-primary text-white" : "hover:bg-primary bg-white"
                          }`}
                      >
                        {t}
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* Customer */}
              <div className="space_18">
                <div className="flex justify-between">
                  <label className="block font-bold mb-2 text-sm">
                    By Customer Name
                  </label>
                  <span className="fs-14 color-red cursor-pointer"
                    onClick={onResetCustomers}
                  >Reset</span>
                </div>
                <MultiSelectDropdown
                  options={customerOptions}
                  selected={selectedCustomers.map((c) => ({
                    label: c,
                    value: c,
                  }))}
                  onChange={onSeletCustomer}
                  placeholder="Search by Customer name / Fund acc id and select"
                />
              </div>


            </div>
            <div className="flex justify-between mt-4 px-2">
              <Button
                variant="transparent"
                onClick={onClose}
              >
                Cancel
              </Button>

              <div className="flex gap-2">
                {isFilterApplied() && (
                  <Button
                    className=""
                    onClick={onReset}
                    variant="lightRed"
                  >
                    Reset
                  </Button>
                )}
                <Button
                  className=""
                  onClick={() => {
                    onApply();
                    onClose();
                  }}
                  variant="contained"
                >
                  Apply
                </Button>
              </div>
            </div>
          </div>
        </div>
      </PanelSlider >
    );
  };
export default CollectionFilterView;
